import { Component, OnInit } from '@angular/core';
// import { FormBuilder, FormGroup } from '@angular/forms';
// import { environment } from '../../environments/environment';
//
// import { Programacion } from '../models/programacion';
// import { ProgramacionService } from '../services/programacion.service';
@Component({
  selector: 'app-cine',
  templateUrl: './cine.component.html',
  styleUrls: ['./cine.component.css']
})
export class CineComponent implements OnInit {


  // models: Programacion[];
  //
  // model: Programacion = new Programacion();
  //
  // url = environment.imgUrl;

  constructor() {

  }
  // constructor(private modelService: ProgramacionService, private formBuilder: FormBuilder) {
  //   this.models = [];
  // }

  ngOnInit() {

    //this.onSubmit();
  }
  //
  // onSubmit() {
  //
  //   let filter = {
  //   }
  //   this.modelService.getFilter(filter).subscribe(val => {
  //     this.models = val;
  //   });
  //
  //   let filter2 = {
  //     "destacado": 1
  //   }
  //
  //   this.modelService.getFilter(filter2).subscribe(val => {
  //     this.model = val[0];
  //   });
  //
  // }


}
